import { render, staticRenderFns } from "./TheNotice.vue?vue&type=template&id=283d8936&scoped=true&"
import script from "./TheNotice.vue?vue&type=script&lang=js&"
export * from "./TheNotice.vue?vue&type=script&lang=js&"
import style0 from "./TheNotice.vue?vue&type=style&index=0&id=283d8936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283d8936",
  null
  
)

export default component.exports